import { Calendar, CalendarRange, MessageSquare } from "lucide-react";
import { MediaKey } from "../../components/marketing/media";

export interface FeatureConfig {
    id: string;
    icon: React.ElementType;
    kicker: string;
    title: string;
    description: string;
    layout: {
        text: number;
        media: number;
    };
    media: MediaKey;
}

export const FEATURES: FeatureConfig[] = [
    {
        id: "assistant",
        icon: MessageSquare,
        kicker: "Your Digital Assistant",
        title: "See your day at a glance",
        description: "Eikos Health sends you confirmations, cancellations, and schedule changes automatically.",
        layout: { text: 4, media: 6 },
        media: "assistant"
    },
    {
        id: "patient-booking",
        icon: Calendar,
        kicker: "Patients find your website or QR code to book in seconds.",
        title: "Your patients don’t need an app or a phone call",
        description: "They use WhatsApp, pick a time, and Eikos Health handles the rest.",
        layout: { text: 4, media: 6 },
        media: "patientDoctor" as MediaKey
    },
    {
        id: "booking-page",
        icon: CalendarRange,
        kicker: "Your digital front desk, always open.",
        title: "Get a clean, professional booking page that works 24/7.",
        description:
            "Link it on your Google Business Profile, Instagram, or your clinic board. Anyone who finds you can book instantly.",
        layout: { text: 4, media: 6 },
        media: "bookingPage" as MediaKey
    }
];
